module.exports = __webpack_public_path__ + "img/welcome_avantage_beaute.e2a05ffa.png";